import React, {Component} from 'react';
import { connect } from "react-redux";
import moment from "moment";
import {onClickScheduledFastForward, onClickScheduledConfirmation, scheduledClean} from '../data/actions/scheduled';
import server from "../../script/store";

/**
 * Component that alerts if you click outside of it
 */
class DialogConfirmation extends Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.onCancelOrderToStore();
        }
    }

    render() {

        const scheduledConfirmation = (this.props.scheduled.scheduled.action.confirmation ?
            this.props.scheduled.scheduled.action.confirmation : []);

        if (scheduledConfirmation.length === 0) {
            return null;
        }


        return (
            <div ref={this.setWrapperRef} className="page-wrap" data-testid='dialog-confirmation'>
                <div className="container">
                    <div className="message animated bounceIn">
                        <div className="display-table">
                            <div className="display-table-cell modal-warning">
                                <div className="modal-warning-header">
                                    <h2>Entregar encomendas na loja?</h2>
                                </div>
                                <div className="modal-warning-body">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>{moment(scheduledConfirmation.deliveryDate).format("HH:mm")}</td>
                                                    <td> - </td>
                                                <td>{scheduledConfirmation.address}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-warning-footer">
                                    <button id="btn_alarm_close" onClick={() => {
                                        this.onSendOrderToStore(scheduledConfirmation)
                                    }}>Aceitar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }

    onSendOrderToStore(order) {
        let orderIds = [];
        orderIds.push(order.id);

        console.log("Push to dispatch.... (" + orderIds + ")");
        this.props.onClickScheduledConfirmation(order);

        server.fastForwardScheduledOrder(orderIds);
    }

    onCancelOrderToStore(order) {
        this.props.scheduledClean();
        return null;
    }

}

const mapDispatchToProps = {
    onClickScheduledFastForward,
    onClickScheduledConfirmation,
    scheduledClean,
}

export default connect(null, mapDispatchToProps)(DialogConfirmation);
